import _classCallCheck from "/mnt/e/www/joinengineconvas/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/mnt/e/www/joinengineconvas/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import { logger } from '@sentry/utils';
import { wrapTransactionWithProfiling } from './hubextensions.js';
import { PROFILE_MAP, findProfiledTransactionsFromEnvelope, createProfilingEvent, addProfilesToEnvelope } from './utils.js';
/**
 * Browser profiling integration. Stores any event that has contexts["profile"]["profile_id"]
 * This exists because we do not want to await async profiler.stop calls as transaction.finish is called
 * in a synchronous context. Instead, we handle sending the profile async from the promise callback and
 * rely on being able to pull the event from the cache when we need to construct the envelope. This makes the
 * integration less reliable as we might be dropping profiles when the cache is full.
 *
 * @experimental
 */

var BrowserProfilingIntegration =
/*#__PURE__*/
function () {
  _createClass(BrowserProfilingIntegration, null, [{
    key: "__initStatic",
    value: function __initStatic() {
      this.id = 'BrowserProfilingIntegration';
    }
  }]);

  function BrowserProfilingIntegration() {
    _classCallCheck(this, BrowserProfilingIntegration);

    this.name = BrowserProfilingIntegration.id;
  }
  /**
   * @inheritDoc
   */


  _createClass(BrowserProfilingIntegration, [{
    key: "setupOnce",
    value: function setupOnce(addGlobalEventProcessor, getCurrentHub) {
      this.getCurrentHub = getCurrentHub;
      var client = this.getCurrentHub().getClient();

      if (client && typeof client.on === 'function') {
        client.on('startTransaction', function (transaction) {
          wrapTransactionWithProfiling(transaction);
        });
        client.on('beforeEnvelope', function (envelope) {
          // if not profiles are in queue, there is nothing to add to the envelope.
          if (!PROFILE_MAP['size']) {
            return;
          }

          var profiledTransactionEvents = findProfiledTransactionsFromEnvelope(envelope);

          if (!profiledTransactionEvents.length) {
            return;
          }

          var profilesToAddToEnvelope = [];
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = profiledTransactionEvents[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var profiledTransaction = _step.value;
              var context = profiledTransaction && profiledTransaction.contexts;
              var profile_id = context && context['profile'] && context['profile']['profile_id'];

              if (!profile_id) {
                (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.log('[Profiling] cannot find profile for a transaction without a profile context');
                continue;
              } // Remove the profile from the transaction context before sending, relay will take care of the rest.


              if (context && context['profile']) {
                delete context.profile;
              }

              var profile = PROFILE_MAP.get(profile_id);

              if (!profile) {
                (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.log("[Profiling] Could not retrieve profile for transaction: ".concat(profile_id));
                continue;
              }

              PROFILE_MAP.delete(profile_id);
              var profileEvent = createProfilingEvent(profile_id, profile, profiledTransaction);

              if (profileEvent) {
                profilesToAddToEnvelope.push(profileEvent);
              }
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }

          addProfilesToEnvelope(envelope, profilesToAddToEnvelope);
        });
      } else {
        logger.warn('[Profiling] Client does not support hooks, profiling will be disabled');
      }
    }
  }]);

  return BrowserProfilingIntegration;
}();

BrowserProfilingIntegration.__initStatic();

export { BrowserProfilingIntegration };